import { CustomReactSelectOption } from '@components/custom-react-select'

export const promocodeTouristVoucherStatusOptions: CustomReactSelectOption[] = [
  { value: 'initial', label: 'Wstępny' },
  { value: 'confirmed', label: 'Potwierdzony' },
  { value: 'used', label: 'Wykorzystany' },
  { value: 'outdated', label: 'Przeterminowany' },
  { value: 'canceled', label: 'Anulowany' },
]
